export default __webpack_public_path__ + "static/media/extensao-minha-encomenda-min.166325e0.png";